import ECGReportComponent from "./ecg-report-component.jsx";
export default ECGReportComponent;
